/**
 * MyTripsPage — list of the driver's trips (mirror of `my_trips_page.dart`).
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus, Loader, Truck } from 'lucide-react';
import { useMyTrips } from '@/hooks/useTrips';
import { AppLayout } from '@/components/layout/AppLayout';
import { TripCard } from '@/components/trips/TripCard';

export default function MyTripsPage() {
  const { t } = useTranslation();
  const { data: trips, isLoading, isError, refetch } = useMyTrips();

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold text-text-primary">{t('my_trips', 'رحلاتي')}</h1>
        <Link
          to="/trips/create"
          className="inline-flex items-center gap-1.5 bg-primary text-white rounded-xl px-4 py-2 text-sm font-semibold hover:bg-primary-light"
        >
          <Plus size={16} /> {t('new_trip', 'رحلة جديدة')}
        </Link>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12 text-text-tertiary">
          <Loader size={28} className="animate-spin" />
        </div>
      ) : isError ? (
        <div className="bg-error/10 text-error rounded-xl p-4 flex items-center justify-between">
          <span>{t('load_failed', 'فشل التحميل')}</span>
          <button onClick={() => refetch()} className="underline">
            {t('retry', 'إعادة المحاولة')}
          </button>
        </div>
      ) : !trips || trips.length === 0 ? (
        <div className="bg-surface border border-border rounded-xl p-10 text-center">
          <Truck size={40} className="mx-auto text-text-tertiary mb-3" />
          <p className="text-text-secondary mb-3">{t('no_trips_yet', 'لم تُنشئ رحلات بعد')}</p>
          <Link
            to="/trips/create"
            className="inline-block bg-primary text-white rounded-xl px-5 py-2.5 text-sm font-semibold"
          >
            {t('create_first_trip', 'أنشئ أول رحلة')}
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {trips.map((trip) => <TripCard key={trip.id} trip={trip} />)}
        </div>
      )}
    </AppLayout>
  );
}
